import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const ADVANCE_PAYMENT_URL = `${process.env.REACT_APP_BACKEND_URL}/advancePayment`;

const initialState = {
  isLoading: false,
  error: null,
  advancePayments: [],
  advancePayment: null,
  page: 1,
  limit: 10,
  totalPages: 0,
  totalResults: 0,
};

const slice = createSlice({
  name: "accountsAdvancePayment",
  initialState,
  reducers: {
    startLoading(state) { state.isLoading = true; state.error = null; },
    hasError(state, action) { state.isLoading = false; state.error = action.payload; },
    getManySuccess(state, action) {
      const payload = action.payload || {};
      const data = payload.data || payload;
      state.isLoading = false;
      state.advancePayments = data.results || data.advancePayments || (Array.isArray(data) ? data : []);
      state.page = data.page || 1;
      state.limit = data.limit || 10;
      state.totalPages = data.totalPages || 0;
      state.totalResults = data.totalResults ?? state.advancePayments.length;
    },
    getOneSuccess(state, action) {
      state.isLoading = false;
      state.advancePayment = action.payload?.data || action.payload;
    },
    clearAdvancePayment(state) { state.advancePayment = null; state.error = null; },
  },
});

export default slice.reducer;

export function getAccountsAdvancePayments({ franchiseId, warehouseId, page = 1, limit = 10 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(ADVANCE_PAYMENT_URL, { params: { franchiseId, warehouseId, page, limit } });
      dispatch(slice.actions.getManySuccess(response.data));
      return response.data;
    } catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
  };
}

export function getAccountsAdvancePayment(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${ADVANCE_PAYMENT_URL}/${id}`);
      dispatch(slice.actions.getOneSuccess(response.data));
      return response.data;
    } catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
  };
}

export function createAccountsAdvancePayment(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(ADVANCE_PAYMENT_URL, data);
      dispatch(slice.actions.getOneSuccess(response.data));
      return response.data;
    } catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
  };
}

export function updateAccountsAdvancePayment(id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`${ADVANCE_PAYMENT_URL}/${id}`, data);
      dispatch(slice.actions.getOneSuccess(response.data));
      return response.data;
    } catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
  };
}

export const { clearAdvancePayment } = slice.actions;
